
import { ApiProperty } from '@nestjs/swagger';

export class FreebieRequest {
    @ApiProperty()
    freebieId: number;
    @ApiProperty()
    freebieCategory: string;
    @ApiProperty()
    description: string;
    @ApiProperty()
    unitPrice: number;
    @ApiProperty()
    companyId: number;
    @ApiProperty()
    departmentId: number;
    @ApiProperty()
    freebieCode: string;
    @ApiProperty()
    startHour: number;
    @ApiProperty()
    startMinutes: number;
    @ApiProperty()
    endHour: number;
    @ApiProperty()
    endMinutes: number;
    @ApiProperty()
    createdUser: string;
    // @ApiProperty()
    // startTime: Date;
    // @ApiProperty()
    // endTime: Date;
    @ApiProperty()
    // @IsOptional()
    // @IsNumber()
    versionFlag: number;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    isActive: boolean | null;
}